module.exports = __webpack_public_path__ + "media/images/emblems/Gempen-blason-3a1ba7afd1b5edf9213d3ac17a361894.png";